function _templateObject() {
    var data = _taggedTemplateLiteral([
        'Setting attributes in the second argument of createEl()has been deprecated. Use the third argument instead.createEl(type, properties, attributes). Attempting to set ',
        ' to ',
        '.'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}
import document from 'global/document';
import window from 'global/window';
import log from './log.js';
import tsml from 'tsml';
import { isObject } from './obj';
import computedStyle from './computed-style';
function isNonBlankString(str) {
    return typeof str === 'string' && /\S/.test(str);
}
function throwIfWhitespace(str) {
    if (/\s/.test(str)) {
        throw new Error('class has illegal whitespace characters');
    }
}
function classRegExp(className) {
    return new RegExp('(^|\\s)' + className + '($|\\s)');
}
export function isReal() {
    return document === window.document;
}
export function isEl(value) {
    return isObject(value) && value.nodeType === 1;
}
export function isInFrame() {
    try {
        return window.parent !== window.self;
    } catch (x) {
        return true;
    }
}
function createQuerier(method) {
    return function (selector, context) {
        if (!isNonBlankString(selector)) {
            return document[method](null);
        }
        if (isNonBlankString(context)) {
            context = document.querySelector(context);
        }
        var ctx = isEl(context) ? context : document;
        return ctx[method] && ctx[method](selector);
    };
}
export function createEl() {
    var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var content = arguments.length > 3 ? arguments[3] : undefined;
    var el = document.createElement(tagName);
    Object.getOwnPropertyNames(properties).forEach(function (propName) {
        var val = properties[propName];
        if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
            log.warn(tsml(_templateObject(), propName, val));
            el.setAttribute(propName, val);
        } else if (propName === 'textContent') {
            textContent(el, val);
        } else {
            el[propName] = val;
        }
    });
    Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
        el.setAttribute(attrName, attributes[attrName]);
    });
    if (content) {
        appendContent(el, content);
    }
    return el;
}
export function textContent(el, text) {
    if (typeof el.textContent === 'undefined') {
        el.innerText = text;
    } else {
        el.textContent = text;
    }
    return el;
}
export function prependTo(child, parent) {
    if (parent.firstChild) {
        parent.insertBefore(child, parent.firstChild);
    } else {
        parent.appendChild(child);
    }
}
export function hasClass(element, classToCheck) {
    throwIfWhitespace(classToCheck);
    if (element.classList) {
        return element.classList.contains(classToCheck);
    }
    return classRegExp(classToCheck).test(element.className);
}
export function addClass(element, classToAdd) {
    if (element.classList) {
        element.classList.add(classToAdd);
    } else if (!hasClass(element, classToAdd)) {
        element.className = (element.className + ' ' + classToAdd).trim();
    }
    return element;
}
export function removeClass(element, classToRemove) {
    if (element.classList) {
        element.classList.remove(classToRemove);
    } else {
        throwIfWhitespace(classToRemove);
        element.className = element.className.split(/\s+/).filter(function (c) {
            return c !== classToRemove;
        }).join(' ');
    }
    return element;
}
export function toggleClass(element, classToToggle, predicate) {
    var has = hasClass(element, classToToggle);
    if (typeof predicate === 'function') {
        predicate = predicate(element, classToToggle);
    }
    if (typeof predicate !== 'boolean') {
        predicate = !has;
    }
    if (predicate === has) {
        return;
    }
    if (predicate) {
        addClass(element, classToToggle);
    } else {
        removeClass(element, classToToggle);
    }
    return element;
}
export function setAttributes(el, attributes) {
    Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
        var attrValue = attributes[attrName];
        if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
            el.removeAttribute(attrName);
        } else {
            el.setAttribute(attrName, attrValue === true ? '' : attrValue);
        }
    });
}
export function getAttributes(tag) {
    var obj = {};
    var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
    if (tag && tag.attributes && tag.attributes.length > 0) {
        var attrs = tag.attributes;
        for (var i = attrs.length - 1; i >= 0; i--) {
            var attrName = attrs[i].name;
            var attrVal = attrs[i].value;
            if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
                attrVal = attrVal !== null ? true : false;
            }
            obj[attrName] = attrVal;
        }
    }
    return obj;
}
export function getAttribute(el, attribute) {
    return el.getAttribute(attribute);
}
export function setAttribute(el, attribute, value) {
    el.setAttribute(attribute, value);
}
export function removeAttribute(el, attribute) {
    el.removeAttribute(attribute);
}
export function blockTextSelection() {
    document.body.focus();
    document.onselectstart = function () {
        return false;
    };
}
export function unblockTextSelection() {
    document.onselectstart = function () {
        return true;
    };
}
export function getBoundingClientRect(el) {
    if (el && el.getBoundingClientRect && el.parentNode) {
        var rect = el.getBoundingClientRect();
        var result = {};
        [
            'bottom',
            'height',
            'left',
            'right',
            'top',
            'width'
        ].forEach(function (k) {
            if (rect[k] !== undefined) {
                result[k] = rect[k];
            }
        });
        if (!result.height) {
            result.height = parseFloat(computedStyle(el, 'height'));
        }
        if (!result.width) {
            result.width = parseFloat(computedStyle(el, 'width'));
        }
        return result;
    }
}
export function findPosition(el) {
    var box;
    if (el.getBoundingClientRect && el.parentNode) {
        box = el.getBoundingClientRect();
    }
    if (!box) {
        return {
            left: 0,
            top: 0
        };
    }
    var docEl = document.documentElement;
    var body = document.body;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var left = box.left + scrollLeft - clientLeft;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var top = box.top + scrollTop - clientTop;
    return {
        left: Math.round(left),
        top: Math.round(top)
    };
}
export function getPointerPosition(el, event) {
    var position = {};
    var box = findPosition(el);
    var boxW = el.offsetWidth;
    var boxH = el.offsetHeight;
    var boxY = box.top;
    var boxX = box.left;
    var pageY = event.pageY;
    var pageX = event.pageX;
    if (event.changedTouches) {
        pageX = event.changedTouches[0].pageX;
        pageY = event.changedTouches[0].pageY;
    }
    position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
    position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
    return position;
}
export function isTextNode(value) {
    return isObject(value) && value.nodeType === 3;
}
export function emptyEl(el) {
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
    return el;
}
export function normalizeContent(content) {
    if (typeof content === 'function') {
        content = content();
    }
    return (Array.isArray(content) ? content : [content]).map(function (value) {
        if (typeof value === 'function') {
            value = value();
        }
        if (isEl(value) || isTextNode(value)) {
            return value;
        }
        if (typeof value === 'string' && /\S/.test(value)) {
            return document.createTextNode(value);
        }
    }).filter(function (value) {
        return value;
    });
}
export function appendContent(el, content) {
    normalizeContent(content).forEach(function (node) {
        return el.appendChild(node);
    });
    return el;
}
export function insertContent(el, content) {
    return appendContent(emptyEl(el), content);
}
export function isSingleLeftClick(event) {
    if (event.button === undefined && event.buttons === undefined) {
        return true;
    }
    if (event.button === 0 && event.buttons === undefined) {
        return true;
    }
    if (event.button === 0 && event.buttons === 0) {
        return true;
    }
    if (event.button !== 0 || event.buttons !== 1) {
        return false;
    }
    return true;
}
export var $ = createQuerier('querySelector');
export var $$ = createQuerier('querySelectorAll');